import { MutableRefObject } from "react";

import { ModalHeader } from "../modal-header";
import {Loader} from "../../loader";

interface ModalStructureProps {
  title?: string;
  size?: string;
  isLoading?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  modalRef: MutableRefObject<HTMLDivElement | null>;
}

export const ModalStructure: React.FC<ModalStructureProps> = ({
  size,
  title,
  onClose,
  children,
  modalRef,
  isLoading,
}) => {
  return (
    <div className="modal-holder">
      <div ref={modalRef} className={`popup-holder ${size || "sm"}`}>
        <ModalHeader title={title} onClose={onClose}/>
        {isLoading ? <Loader /> : children}
      </div>
    </div>
  );
};
